export const divideList = (list, cols) => {
  const arr: Array<any> = [];
  let subArr: Array<string> = [];
  for (let i = 0; i < list.length; i++) {
    subArr.push(list[i]);
    if (subArr.length === cols) {
      arr.push(subArr);
      subArr = [];
    }
  }
  if (subArr.length > 0) {
    arr.push(subArr);
  }
  return arr;
};
